import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import MerchantRequest from "./requestBusiness";
import AppCard from "../../components/dashboard.js/AppCard";
import Loader from "../../components/Loader";
import Iconify from '../../components/Iconify';
import HTTPManager from "../../utils/httpRequestManager";
import AssignMenu from '../Castlenova/Merchant/review/assignMenu';
import ReactApexChart from 'react-apexcharts';

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const PERIOD_LABELS = { today: 'Today', week: 'This Week', month: 'This Month' };

// Pastel colours for payment pie
const PIE_COLORS = ['#4E79A7','#F28E2B','#59A14F','#E15759','#76B7B2','#EDC948','#B07AA1'];

export default class MerchantDashboard extends React.Component {
    httpmanager = new HTTPManager();
    constructor() {
        super();
        this.state = {
            userdetail: {},
            requestNewBusiness: false,
            isLoading: false,
            businessMetrics: {},
            period: 'month',
            statsLoading: false,
            txns: [],
            customers: [],
            payments: [],
        };
        this.loadData = this.loadData.bind(this);
        this.getBusinessMetrics = this.getBusinessMetrics.bind(this);
        this.getDashboardStats = this.getDashboardStats.bind(this);
        this.setPeriod = this.setPeriod.bind(this);
    }

    componentDidMount() { this.loadData(); }

    loadData() {
        const details = window.localStorage.getItem("userdetail") || '';
        if (details !== '') {
            this.setState({ userdetail: JSON.stringify(details) }, () => {
                this.getBusinessMetrics();
                this.getDashboardStats('month');
            });
        }
    }

    getBusinessMetrics() {
        this.setState({ isLoading: true }, () => {
            this.httpmanager.getRequest(`/merchant/getMetrics`).then(response => {
                if (response.data.customerCount !== undefined) {
                    this.setState({ businessMetrics: response.data, isLoading: false });
                } else {
                    this.setState({ isLoading: false, businessMetrics: { customerCount:0, empCount:0, itemsCount:0, categoryCount:0 } });
                }
            }).catch(() => {
                this.setState({ isLoading: false, businessMetrics: { customerCount:0, empCount:0, itemsCount:0, categoryCount:0 } });
            });
        });
    }

    getDashboardStats(period) {
        this.setState({ statsLoading: true });
        this.httpmanager.getRequest(`/merchant/getDashboardStats?period=${period}`).then(res => {
            this.setState({
                txns: res.txns || [],
                customers: res.customers || [],
                payments: res.payments || [],
                statsLoading: false,
            });
        }).catch(() => {
            this.setState({ statsLoading: false });
        });
    }

    setPeriod(period) {
        this.setState({ period }, () => this.getDashboardStats(period));
    }

    getMenuItems() {
        return [
            { Label: 'Download for Windows (.exe)', value: "1" },
            { Label: 'Download for MAC (.dmg)', value: "2" },
        ];
    }

    getappMenuItems() {
        return [{ Label: 'Download for android (.apk)', value: "1" }];
    }

    render() {
        const { period, txns, customers, payments, statsLoading } = this.state;

        // Build line chart data — merge txn & customer date labels
        const allDates = [...new Set([...txns.map(r => r.date), ...customers.map(r => r.date)])].sort();
        const txnMap = Object.fromEntries(txns.map(r => [r.date, Number(r.count)]));
        const custMap = Object.fromEntries(customers.map(r => [r.date, Number(r.count)]));

        const lineOptions = {
            chart: { type: 'area', toolbar: { show: false }, zoom: { enabled: false } },
            colors: ['#0D1727', '#C9A060'],
            dataLabels: { enabled: false },
            stroke: { curve: 'smooth', width: 2 },
            xaxis: { categories: allDates, labels: { rotate: -45, style: { fontSize: '11px' } } },
            yaxis: { labels: { formatter: v => Math.round(v) } },
            tooltip: { y: [{ formatter: v => `${v} txns` }, { formatter: v => `${v} customers` }] },
            legend: { position: 'top' },
            fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.3, opacityTo: 0.05 } },
            grid: { borderColor: '#f0f0f0' },
        };
        const lineSeries = [
            { name: 'Transactions', data: allDates.map(d => txnMap[d] || 0) },
            { name: 'New Customers', data: allDates.map(d => custMap[d] || 0) },
        ];

        // Payment pie
        const payLabels = payments.map(p => p.payMode || 'Other');
        const payValues = payments.map(p => Number(p.total));
        const payTotal = payValues.reduce((a, b) => a + b, 0);

        const pieOptions = {
            chart: { type: 'donut' },
            labels: payLabels,
            colors: PIE_COLORS,
            legend: { position: 'bottom' },
            dataLabels: { formatter: (val) => `${val.toFixed(1)}%` },
            plotOptions: { pie: { donut: { size: '65%' } } },
            tooltip: { y: { formatter: v => `$${Number(v).toFixed(2)}` } },
        };

        return (
            <div>
                {/* ── Download buttons row ── */}
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    <div style={{ display: 'flex', marginRight: '1rem' }}>
                        <AssignMenu label="Download App" toVerify={[]} onClick={(key) => {
                            if (key === '1') window.location.href = process.env.REACT_APP_EXEURL;
                            else if (key === '2') window.location.href = process.env.REACT_APP_DMGURL;
                        }} menuItems={this.getMenuItems()} />
                    </div>
                    <div style={{ display: 'flex', marginRight: '1rem' }}>
                        <AssignMenu label="Download Mobile App" toVerify={[]} onClick={(key) => {
                            if (key === '1') window.location.href = process.env.REACT_APP_APKURL;
                        }} menuItems={this.getappMenuItems()} />
                    </div>
                    {!this.state.requestNewBusiness && this.state.userdetail.userRole === 'Owner' && (
                        <Button variant="contained" onClick={() => this.setState({ requestNewBusiness: true })}>
                            Request New Business
                        </Button>
                    )}
                </div>

                {/* ── Stat cards ── */}
                {this.state.isLoading && <Loader />}
                {!this.state.isLoading && (
                    <Grid container>
                        <Grid item xs={12} sm={6} md={3}>
                            <AppCard Icon={getIcon("mdi:account-group")} Text="Customers" background={"#D0F2FF"} value={this.state.businessMetrics.customerCount} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <AppCard Icon={getIcon("mdi:sitemap")} Text="Categories" background={"#E9FCD4"} value={this.state.businessMetrics.categoryCount} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <AppCard Icon={getIcon("mdi:cash")} Text="Item Orders" background={"#FFF7CD"} value={this.state.businessMetrics.itemsCount} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <AppCard Icon={getIcon("mdi:account-box")} Text="Employees" background={"rgb(255, 231, 217)"} value={this.state.businessMetrics.empCount} />
                        </Grid>
                    </Grid>
                )}

                {/* ── Period filter ── */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '1.5rem', gap: '0.5rem' }}>
                    {Object.entries(PERIOD_LABELS).map(([key, label]) => (
                        <button key={key} onClick={() => this.setPeriod(key)} style={{
                            padding: '6px 16px', borderRadius: '20px', border: '1px solid #0D1727',
                            cursor: 'pointer', fontWeight: 600, fontSize: '0.82rem',
                            backgroundColor: period === key ? '#0D1727' : '#fff',
                            color: period === key ? '#fff' : '#0D1727',
                            transition: 'all 0.2s',
                        }}>{label}</button>
                    ))}
                </div>

                {statsLoading && <div style={{ textAlign: 'center', padding: '2rem', color: '#999' }}>Loading charts…</div>}

                {!statsLoading && (
                    <Grid container spacing={3} style={{ marginTop: '0.5rem' }}>

                        {/* ── Transactions + Customers line chart ── */}
                        <Grid item xs={12} md={8}>
                            <div style={{
                                background: '#fff', borderRadius: '16px',
                                boxShadow: '0 2px 12px rgba(0,0,0,0.07)', padding: '1.25rem',
                            }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#0D1727', marginBottom: '0.5rem' }}>
                                    Transactions &amp; New Customers
                                </Typography>
                                {allDates.length > 0
                                    ? <ReactApexChart options={lineOptions} series={lineSeries} type="area" height={280} />
                                    : <div style={{ height: 280, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa' }}>No data for this period</div>
                                }
                            </div>
                        </Grid>

                        {/* ── Payment breakdown ── */}
                        <Grid item xs={12} md={4}>
                            <div style={{
                                background: '#fff', borderRadius: '16px',
                                boxShadow: '0 2px 12px rgba(0,0,0,0.07)', padding: '1.25rem',
                                height: '100%',
                            }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#0D1727', marginBottom: '0.5rem' }}>
                                    Paid By
                                </Typography>

                                {payments.length > 0 ? (<>
                                    <ReactApexChart options={pieOptions} series={payValues} type="donut" height={200} />
                                    {/* Amount list */}
                                    <div style={{ marginTop: '0.75rem' }}>
                                        {payments.map((p, i) => (
                                            <div key={i} style={{
                                                display: 'flex', justifyContent: 'space-between',
                                                alignItems: 'center', padding: '5px 0',
                                                borderBottom: i < payments.length - 1 ? '1px solid #f3f3f3' : 'none',
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: PIE_COLORS[i % PIE_COLORS.length] }} />
                                                    <Typography variant="body2" style={{ fontWeight: 500 }}>{p.payMode || 'Other'}</Typography>
                                                </div>
                                                <div style={{ textAlign: 'right' }}>
                                                    <Typography variant="body2" style={{ fontWeight: 700 }}>${Number(p.total).toFixed(2)}</Typography>
                                                    <Typography variant="caption" style={{ color: '#999' }}>
                                                        {payTotal > 0 ? ((Number(p.total) / payTotal) * 100).toFixed(1) : 0}%
                                                    </Typography>
                                                </div>
                                            </div>
                                        ))}
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem', paddingTop: '0.5rem', borderTop: '2px solid #0D1727' }}>
                                            <Typography variant="body2" style={{ fontWeight: 700 }}>Total</Typography>
                                            <Typography variant="body2" style={{ fontWeight: 700 }}>${payTotal.toFixed(2)}</Typography>
                                        </div>
                                    </div>
                                </>) : (
                                    <div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa' }}>No payment data</div>
                                )}
                            </div>
                        </Grid>

                    </Grid>
                )}

                {this.state.requestNewBusiness && <MerchantRequest />}
            </div>
        );
    }
}
